import { reportJsonParseException } from '@/src/common/exception';
import {
  ShopInfo, CalculateOut, Spu, SkuItem, addItemActivityTypeItem, Category, SalesInfo
} from '../component';
import {
  CART_ACT_ANIM_TYPE, STATISTICS_NON_VALUE, UserGetMode, SHOP_ACTIVITY_TYPE
} from './constant';

const Statistics = Mach.requireModule('Statistics');

export const CID = 'c_waimai_c_overseas_t0hfbtfg';

export const BID = {
  // 商家详情页-tab栏
  ShopTab: {
    MV: 'b_waimai_c_overseas_9husmj4w_mv',
    MC: 'b_waimai_c_overseas_9husmj4w_mc'
  },
  // 商家详情页-tab栏浮层
  TabMenu: {
    MV: 'b_waimai_c_overseas_8v897jwv_mv',
    MC: 'b_waimai_c_overseas_i1x821q4_mc'
  },
  // 门店信息入口
  ShopDetail: {
    MV: 'b_waimai_c_overseas_59gva0qc_mv',
    MC: 'b_waimai_c_overseas_59gva0qc_mc'
  },
  // 再来一单
  ReOrderModule: {
    MV: 'b_waimai_c_overseas_9v60xpl2_mv',
    MC: 'b_waimai_c_overseas_9v60xpl2_mc'
  },
  // 商家详情页-商品卡片
  FoodItem: {
    MV: 'b_waimai_c_overseas_wlzilhl7_mv',
    MC: 'b_waimai_c_overseas_ohvzd3l8_mc',
  },
  // 购物车 埋点：https://ocean.sankuai.com/config/#/demand/program/edit?flowId=38895&action=detail
  // 购物车
  Cart: {
    MC: 'b_waimai_c_overseas_v5dcdhy9_mc' // 只上报展开MC
  },
  // 购物车-埋单（结算）
  CartBarPay: {
    MC: 'b_waimai_c_overseas_hxd02msb_mc'
  },
  // 购物车-结算校验弹窗（酒类提示、店铺状态变更）
  CartPayDialog: {
    MV: 'b_waimai_c_overseas_gqt96lga_mv'
  },
  // 购物车-提单-最低消费校验弹窗
  CartMinSpendAlert: {
    MV: 'b_sailor_c_0vxv7p8b_mv',
    ConfirmMC: 'b_sailor_c_6xjwvu4f_mc',
    CancelMC: 'b_sailor_c_ny6poz7h_mc'
  },
  // 购物车-浮层(展开)
  CartPop: {
    MV: 'b_waimai_c_overseas_gux41mac_mv'
  },
  // 购物车-清空购物车
  CartDel: {
    MC: 'b_waimai_c_overseas_ch5rstod_mc'
  },
  // 购物车-商品规格展开
  CartSKU: {
    MC: 'b_waimai_c_overseas_5fetruwm_mc'
  },
  // 购物车-浮层-商品卡片信息-加减数量
  CartCount: {
    MC: 'b_waimai_c_overseas_zntwwz7w_mc'
  },
  // 购物车-商品卡片
  CartProductCard: {
    MV: 'b_waimai_c_overseas_0vdjj7sd_mv',
    MC: 'b_waimai_c_overseas_0vdjj7sd_mc'
  },
  // 购物车-底部优惠横条
  CartActivityInfo: {
    MV: 'b_waimai_c_overseas_sw6qbdwk_mv'
  },
  // 准时保
  Punctual: {
    MV: 'b_sailor_c_obx2u4hv_mv',
    MC: 'b_sailor_c_obx2u4hv_mc'
  },
  // 门店页 埋点：https://ocean.sankuai.com/config/#/demand/program/edit?flowId=38895&action=detail
  // 商家详情页-超出配送范围提示
  OutOfDeliveryRange: {
    MV: 'b_waimai_c_overseas_glp4nl58_mv'
  },
  // 商家详情页-吸顶横条(黄条)
  ShopActivityBar: {
    MV: 'b_waimai_c_overseas_o57tr3k5_mv'
  },
  // 优惠券
  ShopActivityList: {
    MV: 'b_sailor_c_1yhylq6e_mv',
    MC: 'b_sailor_c_1yhylq6e_mc'
  },
  // 商品卡片 - 加购按钮(单规格商品（加号、减号）、多规格商品加号) https://ocean.sankuai.com/config/#/module/detail?id=349335&channelId=539&moduleType=child
  ProductCardAddBtn: {
    MC: 'b_sailor_c_5zl5pxvc_mc'
  },
  // 商品卡片 - 单点不送标签
  ProductCardNoSingleTag: {
    MC: 'b_sailor_c_opeh0jk0_mc'
  },
  // 店铺banner
  ShopBanner: {
    MV: 'b_sailor_c_os41kdat_mv',
    MC: 'b_sailor_c_os41kdat_mc'
  },
  // 店铺分㐰
  ShopScore: {
    MV: 'b_sailor_c_ybmd5spe_mv',
    MC: 'b_sailor_c_ybmd5spe_mc'
  },
  // 商家详情页-商品卡片
  DoubleColumnItem: {
    MV: 'b_sailor_c_e36atlnb_mv',
    MC: 'b_sailor_c_e36atlnb_mc',
  },
  // 预售时间弹窗
  AdvanceTime: {
    MV: 'b_sailor_c_xbbsoehl_mv',
  },
  // 门店评价详情页入口
  ShopReviewDetail: {
    MV: 'b_sailor_c_1zjwxtei_mv',
    MC: 'b_sailor_c_1zjwxtei_mc'
  },
  // 全民免运
  DeliveryFree: {
    MV: 'b_sailor_c_r91mb1jf_mv'
  },
  // 门店页切换自取/外卖tab提示强化
  UserGetModeChangeDialog: {
    MC: 'b_sailor_c_nqy7d6wd_mc',
    MV: 'b_sailor_c_nqy7d6wd_mv'
  },

  // 凑单 https://km.sankuai.com/collabpage/2094831928
  /** 门店页凑单入口 */
  AddItemEnrty: {
    MV: 'b_sailor_c_82xrie8l_mv',
    MC: 'b_sailor_c_82xrie8l_mc'
  },
  /** 凑单商品浮层 */
  AddItemPop: {
    MV: 'b_sailor_c_1t0pps8s_mv'
  },
  /** 凑单商品曝光 */
  AddItemProductExposure: {
    MV: 'b_sailor_c_2oaem7q0_mv'
  },
  /** 凑单商品加车 */
  AddItemProductAdd: {
    MC: 'b_sailor_c_7w7rs85g_mc'
  },
  /** 凑单商品减车 */
  AddItemProductDes: {
    MC: 'b_sailor_c_zoz8ecm6_mc'
  },
  // 周年庆标签
  CelebrateShopLabel: {
    MV: 'b_sailor_c_xq2ejf3l_mv'
  },
  CelebrateShopPromotionLabel: {
    MV: 'b_sailor_c_qyjp71mw_mv'
  },
  // 商家详情页-单点不送弹窗
  NoSingle: {
    MV: 'b_sailor_c_f6rrkpjn_mv',
  }
};

export default class TrackUtils {
  static MV = (bid: string, params: any) => {
    Statistics.view(CID, bid, params);
  }

  static MC = (bid: string, params: any) => {
    Statistics.click(CID, bid, params);
  }

  static PV = (params: any) => {
    Statistics.pv(CID, params);
  }

  static shopTabMC = (item: Category, index, shopId) => {
    const params = this.shopTabStatistics(item, index, shopId);
    TrackUtils.MC(BID.ShopTab.MC, params);
  }

  static shopTabMV = (item: Category, index, shopId) => {
    const params = this.shopTabStatistics(item, index, shopId);
    TrackUtils.MV(BID.ShopTab.MV, params);
  }

  static tabMenuMC = (info: ShopInfo) => {
    const params = this.tabMenuStatistics(info);
    TrackUtils.MC(BID.TabMenu.MC, params);
  }

  static tabMenuMV = (info: ShopInfo) => {
    const params = this.tabMenuStatistics(info);
    TrackUtils.MV(BID.TabMenu.MV, params);
  }

  static shopDetailMV = (info: ShopInfo) => {
    const params = this.shopDetail(info);
    TrackUtils.MV(BID.ShopDetail.MV, params);
  }

  static shopDetailMC = (info: ShopInfo) => {
    const params = this.shopDetail(info);
    TrackUtils.MC(BID.ShopDetail.MC, params);
  }

  static reOrderModuleMV = (orderViewId: string, userGetMode) => {
    const params = {
      order_id: orderViewId,
      user_get_mode: userGetMode,
    };
    TrackUtils.MV(BID.ReOrderModule.MV, params);
  }

  static reOrderModuleMC = (orderViewId: string, userGetMode) => {
    const params = {
      order_id: orderViewId,
      user_get_mode: userGetMode,
    };

    TrackUtils.MC(BID.ReOrderModule.MC, params);
  }

  static spuItemMCTag = (spu: Spu, info?: ShopInfo) => {
    const lab = this.spuStatistics(spu, info);
    // Tag和MC上报合并
    TrackUtils.shopTag(lab, BID.FoodItem.MC);
    TrackUtils.MC(BID.FoodItem.MC, lab);
  }

  static spuItemMV = (spu: Spu, info: ShopInfo) => {
    const lab = this.spuStatistics(spu, info);
    TrackUtils.MV(BID.FoodItem.MV, lab);
  }

  static cartMC = (info: ShopInfo) => {
    const params = this.cartShopIdStatistics(info);
    TrackUtils.MC(BID.Cart.MC, params);
  }

  static cartBarPayMCTag = (calculateOut: CalculateOut, info: ShopInfo) => {
    const lab = this.cartBarPayStatistics(calculateOut, info);
    // Tag和MC上报合并
    TrackUtils.shopTag(lab, BID.CartBarPay.MC);
    TrackUtils.MC(BID.CartBarPay.MC, lab);
  }

  static cartPayDialogMV = (remindReason: string, info: ShopInfo) => {
    const params = this.cartPayDialogStatistics(remindReason, info);
    TrackUtils.MV(BID.CartPayDialog.MV, params);
  }

  static cartPopMV = (info: ShopInfo, calculateOut: CalculateOut) => {
    const params = this.cartPopStatistics(info, calculateOut);
    TrackUtils.MV(BID.CartPop.MV, params);
  }

  static cartDelMC = (info: ShopInfo) => {
    const params = this.cartShopIdStatistics(info);
    TrackUtils.MC(BID.CartDel.MC, params);
  }

  static cartSKUMC = (info: ShopInfo, skuItem: SkuItem) => {
    const params = this.cartSKUStatistics(info, skuItem);
    TrackUtils.MC(BID.CartSKU.MC, params);
  }

  static cartCountMC = (info: ShopInfo, skuItem: SkuItem, skuNumber: number, buttonType: number) => {
    const params = this.cartCountStatistics(info, skuItem, skuNumber, buttonType);
    TrackUtils.MC(BID.CartCount.MC, params);
  }

  static cartMinSpendAlertMV = (info: ShopInfo) => {
    const params = this.cartMinSpendAlertStatistics(info);
    TrackUtils.MV(BID.CartMinSpendAlert.MV, params);
  }

  static cartMinSpendAlertConfirmMC = (info: ShopInfo) => {
    const params = this.cartMinSpendAlertStatistics(info);
    TrackUtils.MC(BID.CartMinSpendAlert.ConfirmMC, params);
  }

  static cartMinSpendAlertCancelMC = (info: ShopInfo) => {
    const params = this.cartMinSpendAlertStatistics(info);
    TrackUtils.MC(BID.CartMinSpendAlert.CancelMC, params);
  }

  static cartProductCardMC = (info: ShopInfo, skuItem: SkuItem, index: number) => {
    const params = this.cartProductCardStatistics(info, skuItem, index);
    TrackUtils.MC(BID.CartProductCard.MC, params);
  }

  static cartProductCardMV = (info: ShopInfo, skuItem: SkuItem, index: number) => {
    const params = this.cartProductCardStatistics(info, skuItem, index);
    TrackUtils.MV(BID.CartProductCard.MV, params);
  }

  static cartActivityInfoMV = (logData: {
    margin_min_price: string;
    discount_information: string;
    shop_id: string;
  }, animType = CART_ACT_ANIM_TYPE.START) => {
    let activityTipsArr = [{
      itemTipType: STATISTICS_NON_VALUE,
      itemTip: ''
    }];
    try {
      activityTipsArr = JSON.parse(logData.discount_information);
    } catch (error) {
      activityTipsArr = [{
        itemTipType: STATISTICS_NON_VALUE,
        itemTip: ''
      }];
      // 捕获到异常上报
      reportJsonParseException(error);
    }
    const _logData = {
      ...logData,
    };
    if (animType === CART_ACT_ANIM_TYPE.START) {
      _logData.discount_information = `${activityTipsArr?.[0]?.itemTipType}-${activityTipsArr?.[0]?.itemTip}`;
    }
    if (animType === CART_ACT_ANIM_TYPE.END) {
      _logData.discount_information = `${activityTipsArr?.[1]?.itemTipType}-${activityTipsArr?.[1]?.itemTip}`;
    }
    TrackUtils.MV(BID.CartActivityInfo.MV, _logData);
  }

  static outOfDeliveryRangeMV = (info: ShopInfo) => {
    const params = this.cartShopIdStatistics(info);
    TrackUtils.MV(BID.OutOfDeliveryRange.MV, params);
  }

  static ShopActivityBarMV = (info: ShopInfo) => {
    const params = this.shopActivityBarStatistics(info);
    TrackUtils.MV(BID.ShopActivityBar.MV, params);
  }

  static shopTag = (lab = {}, bid) => {
    Statistics.setTag && Statistics.setTag('sailor_c', {
      [CID]: {
        ...lab,
        bid,
      },
    });
  }

  static productCardAddBtnMC = (button_type: number, spu: Spu, info?: ShopInfo) => {
    const params = this.productCardAddBtnStatistics(button_type, spu, info);
    TrackUtils.MC(BID.ProductCardAddBtn.MC, params);
  }

  static userGetModeChangeDialogMV = (info: ShopInfo, userGetMode) => {
    const params = this.userGetModeChangeDialogMVStatistics(info, userGetMode);
    TrackUtils.MV(BID.UserGetModeChangeDialog.MV, params);
  }

  static userGetModeChangeDialogMC = (info: ShopInfo, userGetMode, buttonType) => {
    const params = this.userGetModeChangeDialogMCStatistics(info, userGetMode, buttonType);
    TrackUtils.MC(BID.UserGetModeChangeDialog.MC, params);
  }

  static productCardNoSingleTagMC = (shopId: string) => {
    const params = {
      shop_id: shopId,
    };
    TrackUtils.MC(BID.ProductCardNoSingleTag.MC, params);
  }

  /**
     * 门店页凑单入口埋点MV
     * @param shopInfo 门店信息
     * @param diffPrice 凑单最小差价
     * @param addItemActivityTypeList 凑单场景 1-凑低消、2-凑满折、3-凑券（可能会同时存在）
     * @returns
     */
  static addItemEnrtyBtnMV = (shopInfo: ShopInfo, addItemActivityTypeList: addItemActivityTypeItem[] = []) => {
    const params = this.addItemEnrtyStatistics(shopInfo, addItemActivityTypeList);
    TrackUtils.MV(BID.AddItemEnrty.MV, params);
  }

  /**
     * 门店页凑单入口埋点MC
     * @param shopInfo 门店信息
     * @param diffPrice 凑单最小差价
     * @param addItemActivityTypeList 凑单场景 1-凑低消、2-凑满折、3-凑券（可能会同时存在）
     * @returns
     */
  static addItemEnrtyBtnMC = (shopInfo: ShopInfo, addItemActivityTypeList: addItemActivityTypeItem[] = []) => {
    const params = this.addItemEnrtyStatistics(shopInfo, addItemActivityTypeList);
    TrackUtils.MC(BID.AddItemEnrty.MC, params);
  }

  /**
     * 凑单商品浮层曝光MV
     * @param shopInfo 门店信息
     * @param addItemActivityTypeList
     */
  static addItemPopMV = (shopInfo: ShopInfo, addItemProductList: Spu[] = []) => {
    const params = this.addItemPopStatistics(shopInfo, addItemProductList);
    TrackUtils.MV(BID.AddItemPop.MV, params);
  }

  /**
     * 凑单商品卡片曝光MV
     * @param shopInfo 门店信息
     * @param spu
     * @param addItemActivityTypeList
     */
  static addItemProductCardMV = (shopInfo: ShopInfo, spu: Spu, addItemActivityTypeList: addItemActivityTypeItem[] = []) => {
    const params = this.addItemCardStatistics(shopInfo, spu, addItemActivityTypeList);
    TrackUtils.MV(BID.AddItemProductExposure.MV, params);
  }

  /**
     * 凑单商品加购点击MC
     * @param shopInfo 门店信息
     * @param spu
     * @param addItemActivityTypeList
     */
  static addItemProductCardAddMC = (shopInfo: ShopInfo, spu: Spu, addItemActivityTypeList: addItemActivityTypeItem[] = []) => {
    const params = this.addItemCardStatistics(shopInfo, spu, addItemActivityTypeList);
    TrackUtils.MC(BID.AddItemProductAdd.MC, params);
  }

  /**
     * 凑单上删除点击MC
     * @param shopInfo 门店信息
     * @param spu
     * @param addItemActivityTypeList 凑单金额列表
     */
  static addItemProductCardDesMC = (shopInfo: ShopInfo, spu: Spu, addItemActivityTypeList: addItemActivityTypeItem[] = []) => {
    const params = this.addItemCardStatistics(shopInfo, spu, addItemActivityTypeList);
    TrackUtils.MC(BID.AddItemProductDes.MC, params);
  }

  /**
     * 周年庆门店标签MV
     * @param info 门店信息
     * @param labelName 标签名称
     */
  static celebrateShopLabelMV = (info: ShopInfo, labelName: string) => {
    const params = this.celebrateShopLabelStatistics(info, labelName);
    TrackUtils.MV(BID.CelebrateShopLabel.MV, params);
  }

  /**
     * 周年庆营销标签MV
     * @param info 门店信息
     * @param labelName 标签名称
     */
  static celebrateShopPromotionLabelMV = (info: ShopInfo, labelName: string) => {
    const params = this.celebrateShopPromotionLabelStatistics(info, labelName);
    TrackUtils.MV(BID.CelebrateShopPromotionLabel.MV, params);
  }

  static noSingleMV = (info: ShopInfo) => {
    const params = {
      shop_id: info.shopId || STATISTICS_NON_VALUE,
    };
    TrackUtils.MV(BID.NoSingle.MV, params);
  }

  private static celebrateShopLabelStatistics = (info: ShopInfo, labelName: string) => ({
    shop_id: info.shopId || STATISTICS_NON_VALUE,
    shop_label: labelName
  })

  private static celebrateShopPromotionLabelStatistics = (info: ShopInfo, labelName: string) => ({
    shop_id: info.shopId || STATISTICS_NON_VALUE,
    promotion_label: labelName
  })

  // 商品卡片埋点参数
  private static productCardAddBtnStatistics = (button_type: number, spu: Spu, info?: ShopInfo,) => {
    const activityType = spu?.activityInfoList?.[0]?.activityType;
    return {
      currency_type: spu?.minPrice?.currency,
      original_price: spu?.minPrice?.amount,
      picture_url: spu?.pictures[0] || '',
      recommended_reason: spu?.recommendInfoList?.length ? spu?.recommendInfoList[0]?.content : '',
      recommended_type: spu?.recommendInfoList?.length ? spu?.recommendInfoList[0]?.recommendType : '',
      spu_id: spu.spuId,
      spu_index: spu.index,
      spu_specifications: spu.availableStatus,
      spu_supply_status: spu.availableStatus,
      tab_index: spu.tab_index,
      tab_name: spu.tab_name,
      shop_id: info?.shopId || '',
      button_type,
      is_new_price: activityType === SHOP_ACTIVITY_TYPE.DISCOUNT_FOOD ? spu.logData?.hasShopNewUserDiscountFood : STATISTICS_NON_VALUE,
      recommended_labels: this.getRecommendedLabels(spu?.salesList) || STATISTICS_NON_VALUE,
      recommended_content: this.getRecommendedContent(spu.salesList) || STATISTICS_NON_VALUE,
      is_single_no_delivery: spu.noSingleInfo?.noSingle === 1 ? 1 : 0,
    };
  }

  // tab栏埋点参数
  private static shopTabStatistics = (sectionItem: Category, index, shopId) => ({
    tab_name: sectionItem?.shopCategoryName || '',
    tab_index: index || 0,
    tab_id: sectionItem?.shopCategoryId || '',
    shop_id: shopId || 0,
  })

  // 埋点参数
  private static tabMenuStatistics = (info: ShopInfo) => ({
    tab_name: '',
    tab_index: 0,
    tab_id: '',
    shop_id: info.shopId,
  })

  // 商品卡片埋点参数
  private static spuStatistics = (spu: Spu, info?: ShopInfo) => {
    const { moduleSource, spuId } = Mach.env.schemeParams || {};
    const activityType = spu?.activityInfoList?.[0]?.activityType;
    return {
      currency_type: spu?.minPrice?.currency,
      original_price: spu?.minPrice?.amount,
      discount_price: spu?.discountPrice?.amount || STATISTICS_NON_VALUE,
      picture_url: spu?.pictures[0] || '',
      recommended_reason: spu?.recommendInfoList?.length ? spu?.recommendInfoList[0]?.content : '',
      recommended_type: spu?.recommendInfoList?.length ? spu?.recommendInfoList[0]?.recommendType : '',
      spu_id: spu.spuId,
      spu_index: spu.index,
      spu_specifications: spu.availableStatus, // 删除
      spu_supply_status: spu.availableStatus,
      tab_index: spu.tab_index,
      tab_name: spu.tab_name,
      shop_id: info?.shopId || STATISTICS_NON_VALUE,
      activity_type: activityType || STATISTICS_NON_VALUE,
      spu_supply_time: spu.availableTime || STATISTICS_NON_VALUE,
      user_get_mode: info?.userGetMode || UserGetMode.delivery,
      module_source: String(spu.spuId) === spuId ? moduleSource : STATISTICS_NON_VALUE,
      spu_calorie: spu?.calorie || '',
      is_customizable: spu?.customizableText !== null ? '1' : '0',
      is_new_price: activityType === SHOP_ACTIVITY_TYPE.DISCOUNT_FOOD ? spu.logData?.hasShopNewUserDiscountFood : STATISTICS_NON_VALUE, // 不存在，字段不上报
      recommended_labels: this.getRecommendedLabels(spu?.salesList) || STATISTICS_NON_VALUE,
      recommended_content: this.getRecommendedContent(spu.salesList) || STATISTICS_NON_VALUE,
      is_single_no_delivery: spu.noSingleInfo?.noSingle === 1 ? 1 : 0,
    };
  }

  private static getRecommendedLabels = (salesInfo: SalesInfo[]) => salesInfo?.map((item) => item.salesType).join(',')

  private static getRecommendedContent = (salesInfo: SalesInfo[]) => salesInfo?.map((item) => item.content).join(',')

  private static shopDetail = (info: ShopInfo) => ({
    average_price: info.avgCostPriceDesc || '-999',
    delivery_price: info.deliveryInfo?.deliveryFee || '-999',
    delivery_time: info.deliveryInfo?.deliveryTime,
    min_price: info.minCostPrice?.displayText || '',
    picture_url: info.logoUrl,
    rating_number: info?.commentInfo?.commentNumber || -1,
    shop_distance: info.distance?.desc,
    shop_id: info.shopId,
    shop_rating: info.reviewsScoreModule?.reviewsScore || '-999',
    shop_spu_type: info?.primaryCategoryName
  })

  // 购物车-埋单（结算）-埋点参数
  private static cartBarPayStatistics = (calculateOut: CalculateOut, info: ShopInfo) => {
    const skuIdList = calculateOut.skuList.map((item) => item.skuId);

    return {
      currency_type: calculateOut.originPrice?.currency, // 货币类型
      delivery_price: calculateOut.discountDeliverFee?.displayText || '', // 配送费
      margin_min_price: calculateOut.minCostPriceTips || '', // 店铺起送价差额
      origin_delivery_price: calculateOut.originDeliverFee?.displayText || '', // 原始配送费
      original_price: calculateOut.originPrice?.displayText || '', // 商品原价
      sale_price: calculateOut.discountPrice?.displayText || '', // 售卖价格
      shop_id: info.shopId, // 商家id
      sku_number: calculateOut.totalCount, // sku商品份数
      skuid_list: skuIdList, // 商品id列表
      discount_information: '', // 优惠信息 删除
      user_get_mode: info.userGetMode || UserGetMode.delivery,
    };
  }
  // 购物车-结算校验弹窗（酒类提示、店铺状态变更）-埋点参数
  private static cartPayDialogStatistics = (remindReason: string, info: ShopInfo) =>
  // 店铺状态变更

    ({
      remind_reason: remindReason, // 提示原因
      shop_id: info.shopId, // 商家id
      user_get_mode: info.userGetMode || UserGetMode.delivery,
    })

  // 购物车-浮层(展开)
  private static cartPopStatistics = (info: ShopInfo, calculateOut: CalculateOut) => ({
    shop_id: info.shopId,
    sku_number: calculateOut?.totalCount || STATISTICS_NON_VALUE, // sku商品份数
    discount_price: calculateOut?.discountPrice?.amount || STATISTICS_NON_VALUE,
    user_get_mode: info.userGetMode || UserGetMode.delivery,
  })

  // 购物车-shopId-埋点参数
  private static cartShopIdStatistics = (info: ShopInfo) => ({
    shop_id: info.shopId,
    user_get_mode: info.userGetMode || UserGetMode.delivery,
  })

  // 购物车-商品规格修改（规格折叠展开）
  private static cartSKUStatistics = (info: ShopInfo, skuItem: SkuItem) => ({
    shop_id: info.shopId,
    sku_id: `${skuItem.spuId}-${skuItem.skuId}`, // 商品id，spu+主商品模块=sku
    user_get_mode: info.userGetMode || UserGetMode.delivery,
  })

  // 购物车-浮层-商品卡片信息-加减数量-埋点参数
  private static cartCountStatistics = (info: ShopInfo, skuItem: SkuItem, skuNumber: number, buttonType: number) => ({
    button_type: buttonType, // 按钮类型0=加车，1=减车
    shop_id: info?.shopId, // 商家id
    sku_id: `${skuItem?.spuId}-${skuItem?.skuId}`, // 商品id，spu+主商品模块sku
    sku_number: skuNumber, // sku商品份数，操作后商品数
    user_get_mode: info.userGetMode || UserGetMode.delivery,
  })

  // 商家详情页-购物车浮层-商品卡片信息-埋点参数
  private static cartProductCardStatistics = (info: ShopInfo, skuItem: SkuItem, index: number) => {
    let groupSkuName = '';
    (skuItem.groupList || []).forEach((item) => {
      (item.groupSkuList || []).forEach((groupSkuItem) => {
        groupSkuName = `${groupSkuName}-${groupSkuItem.name}`;
      });
    });
    const spuSpecifications = `${skuItem.name}-${groupSkuName}-${skuItem.remark}`;

    return {
      currency_type: skuItem.originPrice.currency,
      original_price: skuItem.originPrice.displayText, // 商品原价
      discount_price: skuItem?.discountPrice?.displayText || STATISTICS_NON_VALUE,
      picture_url: skuItem.picture, // 图片链接
      shop_id: info.shopId,
      sku_id: `${skuItem.spuId}-${skuItem.skuId}`,
      sku_index: index, // sku商品卡片次序
      sku_note: skuItem?.remark || STATISTICS_NON_VALUE, // 商品备注
      sku_number: skuItem.count, // sku商品份数
      spu_id: skuItem.spuId, // 商品产品单元
      spu_specifications: spuSpecifications, // 商品规格选择
      user_get_mode: info.userGetMode || UserGetMode.delivery,
    };
  }

  // 商家详情页-吸顶横条（黄条）-埋点参数
  private static shopActivityBarStatistics = (info: ShopInfo) => {
    const { shopId, poiNewUserCouponInfo } = info;
    return {
      coupon_amount: poiNewUserCouponInfo?.counponAmount?.displayText || '', // 券面额
      coupon_id: poiNewUserCouponInfo?.couponId || '', // 优惠券ID
      coupon_min_price: poiNewUserCouponInfo?.sillAmount?.displayText || '', // 券门槛
      subtitle_text: poiNewUserCouponInfo?.title || '', // 副标题
      shop_id: shopId, // 商家id
    };
  }

  private static shopReviewDetailStatistics = (shopInfo: ShopInfo) => {
    const ratingNumber = shopInfo.reviewsScoreModule?.reviewsCntText?.replace(/[\(\)]/g, '');
    return {
      shop_rating: shopInfo.reviewsScoreModule?.reviewsScore || STATISTICS_NON_VALUE,
      shop_id: shopInfo?.shopId,
      rating_number: ratingNumber
    };
  }

  private static cartMinSpendAlertStatistics = (shopInfo: ShopInfo) => ({
    shop_id: shopInfo?.shopId
  })

  /**
     * 门店页凑单入口埋点参数
     * @param shopInfo 门店信息
     * @param addItemActivityTypeList 凑单最小差价
     * @param addItemActivityTypeList 凑单场景 1-凑低消、2-凑满折、3-凑券（可能会同时存在）
     * @returns
     */
  private static addItemEnrtyStatistics = (shopInfo: ShopInfo, addItemActivityTypeList: addItemActivityTypeItem[]) => {
    let addOnType = '';
    let addOnNeedAmount = '';
    (addItemActivityTypeList || []).forEach((item, i) => {
      addOnType += i ? `,${item.type}` : item.type;
      addOnNeedAmount += i ? `,${item.amount}` : item.amount;
    });
    return {
      shop_id: shopInfo?.shopId,
      add_on_need_amount: addOnNeedAmount,
      add_on_type: addOnType
    };
  }

  /**
     * 门店页凑单浮层曝光
     * @param shopInfo
     * @param pageStatus 是否空白页，1-非空白页，0-空白页
     * @returns
     */
  private static addItemPopStatistics = (shopInfo: ShopInfo, addItemProductList: Spu[] = []) => {
    const pageStatus = addItemProductList.length ? 1 : 0;
    return {
      shop_id: shopInfo?.shopId,
      page_status: pageStatus
    };
  }
  private static addItemCardStatistics = (shopInfo: ShopInfo, spu: Spu, addItemActivityTypeList: addItemActivityTypeItem[] = []) => {
    let addOnType = '';
    let addOnNeedAmount = '';
    (addItemActivityTypeList || []).forEach((item, i) => {
      addOnType += i ? `,${item.type}` : item.type;
      addOnNeedAmount += i ? `,${item.amount}` : item.amount;
    });
    return {
      shop_id: shopInfo?.shopId,
      add_on_need_amount: addOnNeedAmount,
      spu_id: spu.spuId,
      original_price: spu.originPrice?.amount,
      picture_url: spu?.pictures?.[0] || STATISTICS_NON_VALUE,
      is_default_picture: spu?.pictures?.[0] ? 0 : 1,
      add_on_type: addOnType
    };
  }

  private static userGetModeChangeDialogMVStatistics = (shopInfo: ShopInfo, userGetMode) => ({
    shop_id: shopInfo.shopId,
    user_get_mode: userGetMode
  })

  private static userGetModeChangeDialogMCStatistics = (shopInfo: ShopInfo, userGetMode, buttonType) => ({
    shop_id: shopInfo.shopId,
    user_get_mode: userGetMode,
    button_type: buttonType // 按钮类型0-取消，1-确认
  })

  static shopActivityListMC = (params) => {
    TrackUtils.MC(BID.ShopActivityList.MC, params);
  }

  static shopActivityListMV = (params) => {
    TrackUtils.MV(BID.ShopActivityList.MV, params);
  }

  // 店铺Banner曝光
  static shopBannerMV = (params) => {
    TrackUtils.MV(BID.ShopBanner.MV, params);
  }

  // 店铺Banner点击
  static shopBannerMC = (params) => {
    TrackUtils.MC(BID.ShopBanner.MC, params);
  }

  // 店铺分曝光
  static shopScoreMV = (params) => {
    TrackUtils.MV(BID.ShopScore.MV, params);
  }

  // 店铺分点击
  static shopScoreMC = (params) => {
    TrackUtils.MC(BID.ShopScore.MC, params);
  }

  static shopReviewDetailMV = (shopInfo: ShopInfo) => {
    // shop_rating、shop_id、rating_number
    const lab = this.shopReviewDetailStatistics(shopInfo);
    TrackUtils.MV(BID.ShopReviewDetail.MV, lab);
  }

  static shopReviewDetailMC = (shopInfo: ShopInfo) => {
    const lab = this.shopReviewDetailStatistics(shopInfo);
    TrackUtils.MC(BID.ShopReviewDetail.MC, lab);
  }

  // 双列 mv
  static spuDoubleColumnItemMV = (spu: Spu, info: ShopInfo) => {
    const lab = this.spuStatistics(spu, info);
    TrackUtils.MV(BID.DoubleColumnItem.MV, { ...lab, spu_type: spu.spuType });
  }

  // 双列mc
  static spuDoubleColumnItemMC = (spu: Spu, info?: ShopInfo) => {
    const lab = this.spuStatistics(spu, info);
    TrackUtils.MC(BID.DoubleColumnItem.MC, { ...lab, spu_type: spu.spuType });
  }
  // 预售时间弹窗
  static advanceTimeMV = (params = {}) => {
    TrackUtils.MV(BID.AdvanceTime.MV, params);
  }
  // 切换业务模式tab
  static switchModeMc = (val) => {
    TrackUtils.MC('b_sailor_c_hmbcm619_mc', val);
  }
  // 自提业务区域曝光
  static pickupModeAreaMv = (val) => {
    TrackUtils.MV('b_sailor_c_oqv8m83s_mv', val);
  }
  // 查看自提商家地图
  static toPickupMapMc = (val) => {
    TrackUtils.MC('b_sailor_c_3rwssc24_mc', val);
  }
  // 全民免运曝光
  static deliveryFreeMv = (val) => {
    TrackUtils.MV(BID.DeliveryFree.MV, val);
  }
  // 收藏弹窗曝光
  static favouritesPopupViewMV = (val) => {
    TrackUtils.MV('b_sailor_c_w76iiq39_mv', val);
  }
  // 收藏弹窗确认按钮点击
  static favouritesPopupViewGotItMC = (val) => {
    TrackUtils.MC('b_sailor_c_pozddux1_mc', val);
  }
  // 收藏按钮mc
  static clickFavoritesBtnMC = (val) => {
    TrackUtils.MC('b_sailor_c_4q3msni1_mc', val);
  }
  // 收藏按钮mv
  static clickFavoritesBtnMV = (val) => {
    TrackUtils.MV('b_sailor_c_4q3msni1_mv', val);
  }

  // 收藏功能引导 mc
  static favoritesGuideMC = (val) => {
    TrackUtils.MC('b_sailor_c_cz800jpg_mc', val);
  }

  // 收藏功能引导 mv
  static favoritesGuideMV = (val) => {
    TrackUtils.MV('b_sailor_c_cz800jpg_mv', val);
  }
}
